import { render, staticRenderFns } from "./CImage.vue?vue&type=template&id=d05415aa&scoped=true"
import script from "./CImage.vue?vue&type=script&lang=ts"
export * from "./CImage.vue?vue&type=script&lang=ts"
import style0 from "./CImage.vue?vue&type=style&index=0&id=d05415aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05415aa",
  null
  
)

export default component.exports